import { postApi } from "./core";
export async function postQuote(req) {
    const resp = await postApi("amm/nfts/quote", req);
    return resp;
}
